import { simpleDisabledText } from '@bit/wavfichacerta.fichacerta.fields-templates.simple-text';

/* col-12 no base: mobile empilha; a partir de md volta ao grid horizontal. */
const sizes = {
  responsavel: "field-fc col-12 col-md-6 col-lg-5 col-xl-5",
  status: "field-fc col-12 col-md-3 col-lg-2 col-xl-2",
  condicao: "field-fc col-12 col-md-3 col-lg-2 col-xl-2",
  observacao: "field-fc col-12 col-md-12 col-lg-3 col-xl-3",
}

export default [
  {
    name: 'firstLine',
    fields: [
      simpleDisabledText({ size: sizes.responsavel, name: 'responsavel_comercial', label: 'Responsável comercial (análise cadastral)' }),
      simpleDisabledText({ size: sizes.status, name: 'status_cliente', label: 'Status do cliente' }),
      simpleDisabledText({ size: sizes.condicao, name: 'condicao_pagamento', label: 'Condição de pagto' }),
      simpleDisabledText({ size: sizes.observacao, name: 'observacao_cliente', label: 'Observações do cliente' }),
    ]
  }
];
